import { Button, Space, Table, Form, Input, Dropdown, Menu, Modal } from "antd";
import vCardsJS from "vcards-js";
import { CSVLink } from "react-csv";
import React from "react";
import { useState, useEffect, useRef } from "react";
import Layout from "../../../components/Layout";
import { Domain, request } from "../../../config/API";
import {
  ReloadOutlined,
  DownloadOutlined,
  DeleteOutlined,
  SearchOutlined,
  DownOutlined,
} from "@ant-design/icons";
import authHeader from "../../../redux/services/authHeader";
import { COLORS } from "../../../config/theme";
import { openNotification } from "../../../redux/actions/Notification/notifications.action";
import moment from "moment";
import { useDebouncedCallback } from "use-debounce";

const headers = [
  { label: "First Name", key: "firstName" },
  { label: "Last Name", key: "lastName" },
  { label: "Phone No", key: "phoneNo" },
  { label: "Email", key: "email" },
  { label: "Job Title/Position", key: "jobTitle" },
  { label: "Company", key: "company" },
  { label: "Address", key: "address" },
  { label: "Comment", key: "comment" },
];
const ListLeadGenerations = () => {
  const { primaryDark, danger } = COLORS;
  const [leadGeneration, setLeadGeneration] = useState([]);
  const [massDownload, setMassDownload] = useState([]);
  const [deleteConformation, setDeleteConformation] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // pagination
  const [count, setCount] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  function handlePageChange(current) {
    setCurrentPage(current);
  }
  function handleSizeChange(a, b, c) {
    setCurrentPage(a);
    setPageSize(b);
  }

  const getLeadGeneration = () => {
    setIsLoading(true);
    request
      .get("leadgeneration/adminLeadgeneration", {
        params: { pageSize, pageNumber: currentPage },
        headers: { ...authHeader() },
      })
      .then(({ data: { data } }) => {
        setLeadGeneration(data?.leadGeneration);
        setCount(data?.count);
        setIsLoading(false);
        // setAdmins(data?.admin);
      })
      .catch((err) => {
        const error = err?.response?.data || "Something Happened";
        openNotification({
          message: "Error",
          description: error,
          icon: "error",
        });
        setIsLoading(false);
      });
  };
  //eslint-disable-next-line
  useEffect(getLeadGeneration, [currentPage, pageSize]);
  const deleteLeadGeneration = (data) => {
    setDeleteConformation(false);
    setIsLoading(true);
    request
      .post("leadgeneration/deleteLeadgeneration", data, {
        headers: { ...authHeader() },
      })
      .then(({ data: { data } }) => {
        setMassDownload([]);
        getLeadGeneration();
      })
      .catch((err) => {
        const error = err?.response?.data || "Something Happened";
        openNotification({
          message: "Error",
          description: error,
          icon: "error",
        });
        setIsLoading(false);
      });
  };
  const handleMenuClick = (e) => {
    if (e.key === "2") {
      setDeleteConformation(true);
    }
  };
  const dropDownMenu = (
    <Menu
      onClick={handleMenuClick}
      items={[
        {
          label: (
            <CSVLink
              filename={`${Date.now()}.csv`}
              data={massDownload}
              headers={headers}
            >
              Mass Download CSV
            </CSVLink>
          ),
          key: "1",
          icon: <DownloadOutlined />,
        },
        {
          label: "Mass Delete",
          key: "2",
          icon: <DeleteOutlined />,
        },
      ]}
    />
  );
  const downloadVCF = (info) => {
    const {
      firstName,
      lastName,
      phoneNo,
      email,
      jobTitle,
      company,
      address,
      comment,
    } = info;
    let vcfCard = vCardsJS();
    if (firstName) vcfCard.firstName = firstName;
    if (lastName) vcfCard.lastName = lastName;
    if (email) vcfCard.email = email;
    if (phoneNo) vcfCard.cellPhone = phoneNo;
    if (jobTitle) vcfCard.title = jobTitle;
    if (company) vcfCard.organization = company;
    if (address) vcfCard.workAddress.street = address;
    if (comment) vcfCard.note = comment;

    const element = document.createElement("a");
    const file = new Blob([vcfCard.getFormattedString()], {
      type: "text/vcard",
    });
    element.href = URL.createObjectURL(file);
    element.download = firstName + ".vcf";
    document.body.appendChild(element);
    element.click();
  };
  // Searching

  const [searchedData, setSearchedData] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [searchvalue, setSearchValue] = useState("");
  const [searchStatus, setSearchStatus] = useState("undecided");
  const onSearch = () => {
    if (searchvalue.length < 1) {
      return;
    }
    setIsSearching(true);
    request
      .post(
        "/user/leadgeneration/search",
        { query: searchvalue },
        { headers: { ...authHeader() } }
      )
      .then(({ data: { data } }) => {
        setSearchedData(data);
        setIsSearching(false);
        setSearchStatus("success");
      })
      .catch((e) => {
        console.log("🚀 ~ file: QRCodes.jsx ~ line 142 ~ onSearch ~ e", e);
        setIsSearching(false);
        setSearchStatus("error");
      });
  };
  useEffect(() => {
    if (searchvalue.length < 1) {
      setSearchedData([]);
      setSearchStatus("undecided");
    }
  }, [searchvalue]);
  const debounced = useDebouncedCallback(() => {
    onSearch();
  }, 500);
  useEffect(() => {
    if (!searchvalue) return;
    debounced(searchvalue);
  }, [debounced, searchvalue]);
  /// multiple downloads
  const truncate = (input) => {
    const temp = input || "";
    return temp?.length > 20 ? `${temp?.substring(0, 20)}...` : temp;
  };
  const Buttons = ({ text }) => {
    const { primaryDark } = COLORS;
    const [open, setOpen] = useState(false);
    function useOutsideAlerter(ref) {
      useEffect(() => {
        function handleClickOutside(event) {
          if (ref.current && !ref.current.contains(event.target)) {
            setOpen(false);
          }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
          document.removeEventListener("mousedown", handleClickOutside);
        };
      }, [ref]);
    }
    const wrapperRef = useRef(null);
    useOutsideAlerter(wrapperRef);
    return (
      <div
        style={{
          position: "relative",
        }}
      >
        <div
          style={{
            cursor: "pointer",
            backgroundColor: primaryDark,
            borderRadius: ".3rem",
            justifyContent: "center",
            textAlign: "center",
            padding: ".5rem",
          }}
          onClick={() => setOpen((prev) => !prev)}
        >
          <span
            style={{ color: "#ffffff", fontWeight: "400", fontSize: "1.15rem" }}
          >
            Action menu
          </span>
        </div>
        {open && (
          <div
            ref={wrapperRef}
            style={{
              position: "absolute",
              right: 0,
              padding: "10px 20px",
              background: "white",
              zIndex: 1,
              borderRadius: "1rem",
              outline: "1px solid lightGray",
              boxShadow: "0px 0px 5px .5px",
            }}
          >
            <Space
              style={{
                flexDirection: "column",
                paddingTop: ".75rem",
                paddingBottom: ".75rem",
              }}
            >
              {text?.profileImage && (
                <Button
                  style={{
                    background: primaryDark,
                    borderColor: primaryDark,
                    fontWeight: "400",
                    fontSize: "1rem",
                  }}
                  shape="round"
                  type="primary"
                  onClick={() => {
                    const url = `${Domain}/data/${text?.profileImage}`;
                    fetch(url).then((response) => {
                      response.blob().then((blob) => {
                        let url = window.URL.createObjectURL(blob);
                        let a = document.createElement("a");
                        a.href = url;
                        a.download = text?.profileImage;
                        a.click();
                      });
                    });
                  }}
                >
                  Download Image
                </Button>
              )}
              {text?.file && (
                <Button
                  style={{
                    background: primaryDark,
                    borderColor: primaryDark,
                    fontWeight: "400",
                    fontSize: "1rem",
                  }}
                  shape="round"
                  type="primary"
                  onClick={() => {
                    const url = `${Domain}/docs/${text?.file}`;
                    fetch(url).then((response) => {
                      response.blob().then((blob) => {
                        let url = window.URL.createObjectURL(blob);
                        let a = document.createElement("a");
                        a.href = url;
                        a.download = text?.file;
                        a.click();
                      });
                    });
                  }}
                >
                  Download File
                </Button>
              )}
              <Button
                style={{
                  background: primaryDark,
                  borderColor: primaryDark,
                  fontWeight: "400",
                  fontSize: "1rem",
                }}
                shape="round"
                type="primary"
                onClick={() => {
                  downloadVCF(text);
                }}
              >
                Download VCF
              </Button>
              <CSVLink
                filename={`${Date.now()}.csv`}
                headers={headers}
                data={[text]}
              >
                <Button
                  shape="round"
                  type="primary"
                  style={{
                    background: primaryDark,
                    borderColor: primaryDark,
                    fontWeight: "400",
                    fontSize: "1rem",
                  }}
                >
                  Download CSV
                </Button>
              </CSVLink>
              <Button
                style={{
                  background: primaryDark,
                  borderColor: primaryDark,
                  fontWeight: "400",
                  fontSize: "1rem",
                }}
                shape="round"
                type="primary"
                onClick={() => {
                  deleteLeadGeneration([text]);
                }}
              >
                Delete Lead
              </Button>
            </Space>
          </div>
        )}
      </div>
    );
  };
  const LongTextDisplay = ({ text }) => {
    const [open, setOpen] = useState(false);
    function useOutsideAlerter(ref) {
      useEffect(() => {
        function handleClickOutside(event) {
          if (ref.current && !ref.current.contains(event.target)) {
            setOpen(false);
          }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
          document.removeEventListener("mousedown", handleClickOutside);
        };
      }, [ref]);
    }
    const wrapperRef = useRef(null);
    useOutsideAlerter(wrapperRef);
    return (
      <div
        style={{
          position: "relative",
        }}
      >
        <div
          style={{ cursor: "pointer", fontWeight: "400", fontSize: "1.15rem" }}
          onClick={() => setOpen((prev) => !prev)}
        >
          <span>{truncate(text)}</span>
        </div>
        {open && (
          <div
            ref={wrapperRef}
            style={{
              position: "absolute",
              right: 0,
              padding: "10px 20px",
              background: "white",
              outline: "1px solid lightGray",
              boxShadow: "0px 0px 5px .5px",
              zIndex: 1,
              borderRadius: "1rem",
              width: "25rem",
              fontWeight: "400",
              fontSize: "1.15rem",
            }}
          >
            <Space
              style={{
                flexDirection: "column",
                paddingTop: ".75rem",
                paddingBottom: ".75rem",
              }}
            >
              <span>{text}</span>
            </Space>
          </div>
        )}
      </div>
    );
  };
  const Website = ({ text }) => {
    const [open, setOpen] = useState(false);
    function useOutsideAlerter(ref) {
      useEffect(() => {
        function handleClickOutside(event) {
          if (ref.current && !ref.current.contains(event.target)) {
            setOpen(false);
          }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
          document.removeEventListener("mousedown", handleClickOutside);
        };
      }, [ref]);
    }
    const wrapperRef = useRef(null);
    useOutsideAlerter(wrapperRef);
    return (
      <div
        style={{
          position: "relative",
        }}
      >
        <div
          style={{ cursor: "pointer", fontWeight: "400", fontSize: "1.15rem" }}
          onClick={() => setOpen((prev) => !prev)}
        >
          <span>{truncate(text)}</span>
        </div>
        {open && (
          <div
            ref={wrapperRef}
            style={{
              position: "absolute",
              right: 0,
              padding: "10px 20px",
              background: "white",
              outline: "1px solid lightGray",
              boxShadow: "0px 0px 5px .5px",
              zIndex: 1,
              borderRadius: "1rem",
              width: "25rem",
              fontWeight: "400",
              fontSize: "1.15rem",
            }}
          >
            <Space
              style={{
                flexDirection: "column",
                paddingTop: ".75rem",
                paddingBottom: ".75rem",
              }}
            >
              <span
                style={{
                  cursor: "pointer",
                  fontWeight: "400",
                  fontSize: "1.15rem",
                }}
                onClick={() => {
                  window.open(text, "_blank");
                }}
              >
                {text}
              </span>
            </Space>
          </div>
        )}
      </div>
    );
  };
  const Email = ({ text }) => {
    const [open, setOpen] = useState(false);
    function useOutsideAlerter(ref) {
      useEffect(() => {
        function handleClickOutside(event) {
          if (ref.current && !ref.current.contains(event.target)) {
            setOpen(false);
          }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
          document.removeEventListener("mousedown", handleClickOutside);
        };
      }, [ref]);
    }
    const wrapperRef = useRef(null);
    useOutsideAlerter(wrapperRef);
    return (
      <div
        style={{
          position: "relative",
        }}
      >
        <div
          style={{ cursor: "pointer", fontWeight: "400", fontSize: "1.15rem" }}
          onClick={() => setOpen((prev) => !prev)}
        >
          <span>{truncate(text)}</span>
        </div>
        {open && (
          <div
            ref={wrapperRef}
            style={{
              position: "absolute",
              right: 0,
              padding: "10px 20px",
              background: "white",
              outline: "1px solid lightGray",
              boxShadow: "0px 0px 5px .5px",
              zIndex: 1,
              borderRadius: "1rem",
              width: "25rem",
              fontWeight: "400",
              fontSize: "1.15rem",
            }}
          >
            <Space
              style={{
                flexDirection: "column",
                paddingTop: ".75rem",
                paddingBottom: ".75rem",
              }}
            >
              <span
                style={{
                  cursor: "pointer",
                  fontWeight: "400",
                  fontSize: "1.15rem",
                }}
                onClick={() => {
                  window.open("mailto:" + text);
                }}
              >
                {text}
              </span>
            </Space>
          </div>
        )}
      </div>
    );
  };
  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      setMassDownload(selectedRows);
    },
  };
  const columns = [
    {
      title: "",
      key: "checkbox",
      width: "3%",
    },
    {
      title: "First Name",
      dataIndex: "firstName",
      key: "firstName",
      width: "12%",
      render: (item) => {
        return (
          <span style={{ fontWeight: "400", fontSize: "1.15rem" }}>{item}</span>
        );
      },
    },
    {
      title: "Last Name",
      dataIndex: "lastName",
      key: "lastName",
      width: "12%",
      render: (item) => {
        return (
          <span style={{ fontWeight: "400", fontSize: "1.15rem" }}>{item}</span>
        );
      },
    },
    {
      title: "Company Name",
      dataIndex: "company",
      key: "company",
      width: "16%",
      render: (item) => {
        return (
          <span style={{ fontWeight: "400", fontSize: "1.15rem" }}>{item}</span>
        );
      },
    },
    {
      title: "Job Title/Position",
      dataIndex: "jobTitle",
      key: "jobTitle",
      width: "16%",
      render: (item) => {
        return (
          <span style={{ fontWeight: "400", fontSize: "1.15rem" }}>{item}</span>
        );
      },
    },
    {
      title: "Address",
      dataIndex: "address",
      key: "address",
      width: "16%",
      render: (text) => {
        return <LongTextDisplay text={text} />;
      },
    },
    {
      title: "Phone Number",
      dataIndex: "phoneNo",
      key: "phoneNo",
      width: "16%",
      render: (item) => {
        return (
          <span
            style={{
              cursor: "pointer",
              fontWeight: "400",
              fontSize: "1.15rem",
            }}
            onClick={() => {
              window.open("tel:" + item);
            }}
          >
            {item}
          </span>
        );
      },
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      width: "16%",
      render: (text) => {
        return <Email text={text} />;
      },
    },
    {
      title: "Website",
      dataIndex: "website",
      key: "website",
      width: "16%",
      render: (text) => {
        return <Website text={text} />;
      },
    },
    {
      title: "Comment",
      dataIndex: "comment",
      key: "comment",
      width: "16%",
      render: (text) => {
        return <LongTextDisplay text={text} />;
      },
    },
    {
      title: "Card Owner",
      dataIndex: "cardOwner",
      key: "cardOwner",
      width: "16%",
      render: (item) => {
        return (
          <span style={{ fontWeight: "400", fontSize: "1.15rem" }}>
            {item?.fullName}
          </span>
        );
      },
    },
    {
      width: "16%",
      title: "Date",
      dataIndex: "updatedAt",
      key: "updatedAt",
      render: (item) => {
        return (
          <span style={{ fontWeight: "400", fontSize: "1.15rem" }}>
            {moment(new Date(item)).format("D/MM/YYYY")}
          </span>
        );
      },
    },
    {
      title: "Actions",
      key: "actions",
      render: (text) => {
        return <Buttons text={text} />;
      },
      width: "6%",
    },
  ];
  return (
    <Layout heading="Lead Inbox" hasBadge stat={count}>
      <Space
        style={{ marginBottom: 24, marginTop: 24, float: "right" }}
        wrap={true}
      >
        <Form
          onFinish={() => {
            if (searchvalue === "") {
              alert("Please enter some value!");
            } else {
              onSearch();
            }
          }}
          onFinishFailed={(x) => {
            console.log(x);
          }}
          style={{ display: "flex" }}
        >
          <Form.Item
            name="search"
            // label="Search"
            style={{ margin: 0 }}
          >
            <Input
              style={{ borderTopLeftRadius: 50, borderBottomLeftRadius: 50 }}
              allowClear
              value={searchvalue}
              onChange={(e) => {
                setSearchValue(e.target.value);
              }}
              placeholder="Search ..."
            />
          </Form.Item>
          <Form.Item style={{ margin: 0 }}>
            <Button
              type="primary"
              style={{
                width: 50,
                background: primaryDark,
                borderTopRightRadius: 50,
                borderBottomRightRadius: 50,
                border: "none",
                paddingLeft: 10,
                paddingRight: 10,
              }}
              htmlType="submit"
              loading={isSearching}
              icon={<SearchOutlined />}
            />
          </Form.Item>
        </Form>
        <Dropdown
          disabled={massDownload.length > 0 ? false : true}
          overlay={dropDownMenu}
        >
          <Button
            style={{
              background: massDownload.length > 0 ? primaryDark : "#BFBFBF",
              borderColor: massDownload.length > 0 ? primaryDark : "white",
              fontWeight: "400",
              fontSize: "1rem",
              color: massDownload.length > 0 ? "white" : primaryDark,
            }}
            shape="round"
            type="primary"
          >
            Select Option
            <DownOutlined />
          </Button>
        </Dropdown>
        <Button
          shape="round"
          type="primary"
          style={{ background: primaryDark, borderColor: primaryDark }}
          onClick={getLeadGeneration}
          icon={<ReloadOutlined />}
        >
          Refresh
        </Button>
      </Space>
      <Table
        size="large"
        dataSource={
          searchvalue.length > 0 && searchStatus === "success"
            ? searchedData
            : leadGeneration
        }
        rowSelection={{
          type: "checkbox",
          ...rowSelection,
        }}
        rowKey={({ _id }) => _id}
        columns={columns}
        loading={isLoading || isSearching}
        pagination={{
          hideOnSinglePage: true,
          pageSize: pageSize,
          current: currentPage,
          total: count,
          showTotal: (total, range) =>
            `${range[0]}-${range[1]} of ${total} items`,
          // showTotal: (total) => `Total ${total} items`,
          onChange: handlePageChange,
          showSizeChanger: true,
          onShowSizeChange: handleSizeChange,
        }}
      />
      <Modal
        title="Delete Lead"
        visible={deleteConformation}
        footer={null}
        onCancel={() => setDeleteConformation(false)}
        centered
      >
        <div style={{ textAlign: "center" }}>
          <p style={{ color: danger }}>Are you sure you want to delete?</p>

          <div
            style={{
              marginTop: "1rem",
            }}
          >
            <Button
              shape="round"
              type="primary"
              style={{
                background: primaryDark,
                borderColor: primaryDark,
                marginRight: "1rem",
                marginLeft: "1rem",
              }}
              onClick={() => setDeleteConformation(false)}
            >
              No
            </Button>
            <Button
              shape="round"
              type="primary"
              style={{
                background: primaryDark,
                borderColor: primaryDark,
                marginRight: "1rem",
                marginLeft: "1rem",
              }}
              onClick={() => {
                deleteLeadGeneration(massDownload);
              }}
            >
              Yes
            </Button>
          </div>
        </div>
      </Modal>
    </Layout>
  );
};

export default ListLeadGenerations;
